enum IconEnum {
  // Assets
  MATH = "theme:icons/math.svg",
  MATH_COLOR = "theme:icons/math_color.svg",
  K2_MATH = "theme:icons/math.svg",
  ABLD_MATH = "theme:icons/abld_math.svg",
  READING = "theme:icons/reading.svg",
  READING_COLOR = "theme:icons/reading_color.svg",
  K2_READING = "theme:icons/reading.svg",
  ABLD_READING = "theme:icons/abld_reading.svg",
  ENGLISH = "theme:icons/reading.svg",
  ABLD_SCIENCE = "theme:icons/abld_science.svg",
  ABLD_INVERTED_MATH = "theme:icons/abld_inverted_math.svg",
  ABLD_INVERTED_READING = "theme:icons/abld_inverted_reading.svg",
  ABLD_INVERTED_SCIENCE = "theme:icons/abld_inverted_science.svg",
  SEL = "theme:icons/sel.svg",
  SCIENCE = "theme:icons/science.svg",
  STAR = "assets:icons/star.svg",
  LOGO_BUG = "assets:icons/logo-bug.svg",
  TEXT_TO_SPEECH = "assets:icons/text-to-speech.svg",
  LANGUAGE_TRANSLATION = "assets:icons/language-translation.svg",
  MY_PATH_LOGO = "assets:icons/my-path-logo.svg",
  GUIDED_NOTES = "assets:icons/guided-notes.svg",
  COLLECT_HIGHLIGHTS = "assets:icons/collect-highlights.svg",
  GREEN_CIRCLE_CHECK = "assets:icons/green-circle-check.png",
  RED_CIRCLE_XMARK = "assets:icons/red-circle-xmark.png",

  // Font Awesome
  ARROW_ALT_DOWN = "arrow-alt-down",
  ARROW_LEFT = "arrow-left",
  ARROW_RIGHT = "arrow-right",
  ARROW_CIRCLE_LEFT = "arrow-circle-left",
  ARROW_CIRCLE_RIGHT = "arrow-circle-right",
  ARROW_SQUARE_LEFT = "arrow-square-left",
  ARROW_SQUARE_RIGHT = "arrow-square-right",
  BARS = "bars",
  BOOK = "book",
  BOOKS = "books",
  BOOK_OPEN = "book-open",
  BOOK_OPEN_COVER = "book-open-cover",
  BOOK_READER = "book-reader",
  BUILDING = "building",
  CALCULATOR_ALT = "calculator-alt",
  CALENDAR = "calendar",
  CALENDAR_DAYS = "calendar-days",
  CHART_AREA = "chart-area",
  CHART_LINE = "chart-line",
  CHEVRON_DOWN = "chevron-down",
  CHEVRON_UP = "chevron-up",
  CHEVRON_LEFT = "chevron-left",
  CHEVRON_RIGHT = "chevron-right",
  CHECK = "check",
  CHECK_CIRCLE = "check-circle",
  CHECK_SQUARE = "check-square",
  CIRCLE = "circle",
  CIRCLE_CHECK = "circle-check",
  CIRCLE_EXCLAMATION = "circle-exclamation",
  CIRCLE_INFO = "circle-info",
  CIRCLE_NOTCH = "circle-notch",
  CIRCLE_QUESTION = "circle-question",
  COMMENT_QUESTION = "comment-question",
  DOT_CIRCLE = "dot-circle",
  ELLIPSIS_V = "ellipsis-v",
  ERASER = "eraser",
  EXPAND_RIGHT = "expand-right",
  FILTER = "filter",
  GEAR = "gear",
  GRADUATION_CAP = "graduation-cap",
  GREATER_THAN = "greater-than",
  GRID = "grid",
  HIGHLIGHTER = "highlighter",
  HISTORY = "history",
  HOUSE = "house",
  ID_BADGE = "id-badge",
  IL_PLUS_BRAND = "il-plus-brand",
  IMAGES = "images",
  INFO_CIRCLE = "info-circle",
  LESS_THAN = "less-than",
  LIGHTBULB = "lightbulb",
  LIGHTBULB_ON = "lightbulb-on",
  LINK = "link",
  LOCK = "lock",
  LOCK_ALT = "lock-alt",
  MAGNIFYING_GLASS = "magnifying-glass",
  MAP_MARKER_ALT = "map-marker-alt",
  MEMO_CIRCLE_CHECK = "memo-circle-check",
  MINUS = "minus",
  MINUS_CIRCLE = "minus-circle",
  MINUS_SQUARE = "minus-square",
  MYPATH_BRAND = "mypath-brand",
  PAUSE = "pause",
  PENDO_QUESTION = "pendo-question",
  PLAY = "play",
  PLUS = "plus",
  PLUS_CIRCLE = "plus-circle",
  PLUS_SQUARE = "plus-square",
  POWER_OFF = "power-off",
  QUESTION_CIRCLE = "question-circle",
  ROTATE_RIGHT = "rotate-right",
  SORT = "sort",
  SORT_UP = "sort-up",
  SORT_DOWN = "sort-down",
  STOP = "stop",
  SQUARE = "square",
  TH = "th",
  TH_LIST = "th-list",
  TIMES = "times",
  TIMES_CIRCLE = "times-circle",
  USER = "user",
  USER_CIRCLE = "user-circle",
  USER_EDIT = "user-edit",
  USER_HEADSET = "user-headset",
  USERS = "users",
  VOLUME = "volume",
  WRENCH = "wrench",
  XMARK = "xmark",
  ARROW_UP_RIGHT_FROM_SQUARE = "arrow-up-right-from-square"
}
export default IconEnum;
